/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KostenstellennummerInputs */

const de__field_kostenstellennummer = /** @type {(inputs: _Field_KostenstellennummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenstellennummer`)
};

/**

* @param {_Field_KostenstellennummerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kostenstellennummer = /** @type {((inputs?: _Field_KostenstellennummerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KostenstellennummerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kostenstellennummer(inputs)
});